import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { formatINRShort } from "../../utils/crmDealValue";

const Customer360Panel = ({ leadId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  useEffect(() => {
    if (!leadId) return;
    let cancelled = false;
    fetch(`${url}/leads/customer-360/${leadId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [leadId, url, token]);

  if (!leadId) return null;
  if (loading) return <p className="crm-insights__muted">Loading Customer 360…</p>;
  if (!data) return null;

  const { customer, enquiryHistory, invoices, receipts, totals } = data;

  return (
    <div className="crm-customer-360">
      <h4 className="crm-customer-360__title">Customer 360</h4>

      <div className="crm-insights__kpis">
        <div className="crm-insights__kpi">
          <span className="crm-insights__kpi-label">Enquiries</span>
          <span className="crm-insights__kpi-value">{totals.enquiryCount}</span>
        </div>
        <div className="crm-insights__kpi">
          <span className="crm-insights__kpi-label">Open pipeline</span>
          <span className="crm-insights__kpi-value">
            {formatINRShort(totals.openPipelineValue) || "₹0"}
          </span>
        </div>
        <div className="crm-insights__kpi">
          <span className="crm-insights__kpi-label">Outstanding</span>
          <span className="crm-insights__kpi-value">
            {formatINRShort(totals.outstanding) || "₹0"}
          </span>
        </div>
      </div>

      {customer && (
        <p className="crm-customer-360__link">
          <Link to={`/customer-detail/${customer.id}`}>
            View customer {customer.cust_ID || customer.customerName}
          </Link>
        </p>
      )}

      {enquiryHistory?.length > 1 && (
        <div className="crm-customer-360__section">
          <strong>Enquiry history</strong>
          {enquiryHistory.slice(0, 5).map((e) => (
            <div key={e.id} className="crm-insights__source-row">
              <span>{e.extra || "Uncontacted"}</span>
              <span>{new Date(e.createdAt).toLocaleDateString("en-IN")}</span>
            </div>
          ))}
        </div>
      )}

      {invoices?.length > 0 && (
        <div className="crm-customer-360__section">
          <strong>Recent invoices</strong>
          {invoices.map((inv) => (
            <div key={inv.id} className="crm-insights__source-row">
              <span>{inv.invoice_number || inv.order_number}</span>
              <span>{formatINRShort(Number(inv.grand_total))}</span>
            </div>
          ))}
        </div>
      )}

      {receipts?.length > 0 && (
        <div className="crm-customer-360__section">
          <strong>Recent receipts</strong>
          {receipts.map((r) => (
            <div key={r.id} className="crm-insights__source-row">
              <span>{r.invoiceNumber || `Receipt #${r.id}`}</span>
              <span>{formatINRShort(Number(r.amount))}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Customer360Panel;
